<template>
  <div class="hello">
    <div class="panLat">
      <div class="nome">{{ nome }}</div>
      <div class="pLatInfos">
        <h2 class="tittle">Projetos atuais</h2>
        <h3>Sistema de ERP Desktop na empresa Companysys Soluções</h3>
        <p class="infoExt">
          Desenvolvemos este sistema desde 2015 que tem como foco auxiliar o cliente com
          vendas de mercadorias, controle de estoque, emissão de cupom e notas fiscais.
        </p>

        <h2 class="tittle">Tecnologias utilizadas</h2>
        <p class="infoExt">
          Projeto é inicialmente desenvolvido quase de forma integral com Object Pascal e
          banco de dados relacional MySQL, o mesmo vem sofrendo atualizações para que se
          possa entregar ao cliente um produto completo com aplicações em nuvem e mobile,
          adicionando aos poucos novas funcionalidades.
        </p>

        <h2 class="tittle">Objetivos a alcançar</h2>
        <p class="infoExt">
          O término da nossa API ajudará muito na escalabilidade deste produto, com isso
          poder entregar a solução web livre de um computador servidor caso o cliente não
          tenha condições ou intenção de adiquirir um para que possa disfrutar de um
          produto que realmente veio para ajudar seu estabelecimento a conseguir melhores
          resultados.
        </p>
      </div>
    </div>
    <article class="mainInfo">
      <h1 class="objetivo">{{ objetivo }}</h1>
      <p class="pInfos">
        <span
          ><i class="fas fa-phone"></i> <strong>Telefone:</strong> +55
          {{ telefones }}</span
        >
        <span><i class="fas fa-at"></i> <strong> Email: </strong> {{ email }}</span>
        <span><i class="fas fa-map-marker-alt"></i> <strong>São Paulo - SP</strong></span>
      </p>
      <div class="detInfos">
        <span> <strong> Nacionalidade: </strong> {{ nacionalidade }}</span>
        <span> <strong> Estado Civil: </strong> {{ estadoCivil }}</span>
      </div>
      <div class="resumo">
        <h1 class="tittle">RESUMO</h1>
        <p class="tRes">{{ sobre }}</p>
      </div>
      <div class="resumo">
        <h1 class="tittle">Objetivo</h1>
        <p class="tRes">{{ objetivo2 }}</p>
      </div>
      <div class="resumo">
        <h1 class="tittle">Qualificações</h1>
        <ul v-for="(item, index) in qualificacoes" :key="index">
          <li>
          <div class="detItemQ">
            <span v-if="item.tit">{{ item.tit }}</span>
            <span :class="{
              strong:
                item.value.includes('Javascript') ||
                item.value.includes('VueJS') ||
                item.value.includes('HTML') ||
                item.value.includes('MySQL'),
            }">{{ item.value }}</span>
          </div>          
          </li>
        </ul>
      </div>
      <div class="resumo">
        <h1 class="tittle">Experiência</h1>
        <ul v-for="(item, index) in experiencia" :key="index">
          <li>
            <h2 class="tittle bnone">{{ item.local }}</h2>
            <p class="tRes">{{ item.atividade }}</p>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "MeuCurriculo",
  data() {
    return {
      nome: "Albert Wallac Miguel da Silva",
      endereco: "Av. Moares Costa, 453 - Apto. 5 CEP: 03253-000",
      nacionalidade: "Brasileiro",
      estadoCivil: "Casado",
      telefones: "(11) 93800-9278",
      email: "albertwallac@gmail.com, albert@companysys.com.br",
      objetivo: "Desenvolvedor Full Stack | Object Pascal | C | C# | Javascript | Java",
      objetivo2:
        "Tomei ciência da necessidade atual da sua organização e as competências profissionais que estão procurando, acredito que com as habilidades que desenvolvi por todos estes anos eu possa contribuir muito com sua equipe.",
      qualificacoes: [
        {tit:'',value:"Vivencia com atendimento ao público"},
        {tit:'',value:"Sou um profissional com nível de atuação diversificada"},
        {tit:'',value:"Habilitado em redes, hardwarde e desenvolvimento"},
        {tit:'',value:"Forte capacidade de adaptação e aprendizagem"},
        {tit:'',value:"Profissional com soluções criativas que agregam valor ao produto"},
        {tit:'Desenvolvimento:',value:"Object Pascal, C, C#, Javascript e Java"},
        {tit:'Frameworks:',value:"Delphi, Lazarus, VueJS, NodeJS"},
        {tit:'Habilidades complementares:',value:"HTML, CSS"},
        {tit:'Bancos de dados:',value:"PostgreSQL e MySQL"},
        {tit:'',value:"Um profissional acostumado a receber grandes responsabilidades e tarefas de confiança."}
      ],
      formacao: "Universidade Nove de Julho: Ciências da Computação ( Sem conclusão )",
      experiencia: [
        {
          local: "COMPANYSYS SOLUÇÔES LTDA",
          atividade:
            "Empresa onde atualmente sou um dos sócios, nela temos um sistema ERP com um grupo de clientes modesto. Aqui faço a parte de suporte, desenvolvimento e consultoria.",
        },
        {
          local: "TELEPERFORMANCE BRASIL",
          atividade: `Fui responsável pelas negociações de carteiras bancárias em processos jurídicos em ações cíveis, tratando diretamente com os autores ou seus advogados. [ Análise e resolução de processos cíveis ]`,
        },
        {
          local: "ATENTO BRASIL S/A",
          atividade:
            "Cuidava de atritos decorrentes de erro sistêmico ou contratuais para reduzir ou sanar problemas financeiros dos clientes do banco Bradesco, e mais tarde na mesma empresa, atuei com mesma tarefas porém com certa importância agregada nos casos encaminhados ao PROCON do mesmo banco.",
        },
      ],
      sobre: `Sou uma pessoa que se adapta a qualquer ambiente de trabalho com facilidade e sem exceção, acostumado a receber tarefas com certo grau de dificuldade, que aceita a responsabilidade e a cumpre com maestria para chegar ao resultado desejado, como também para mostrar que a confiança depositada em mim tem recompensa, nada menos que um trabalho bem executado.
    Sou do tipo de pessoa que se obriga a entregar o melhor e com foco na atividade proposta, que está pronto a ajudar onde for preciso, e desde o primeiro momento se molda para ser relevante onde estiver. `,
    };
  },
};
</script>

<style scoped>
* {
  font-size: 12px;
}
.hello {
  color: aliceblue;
  display: flex;
  overflow: hidden;
  min-height: 100vh;
  margin: 0 auto;
}
.panLat {
  padding: 12px;
  background: linear-gradient(
    to bottom,
    rgb(15, 41, 114),
    rgb(12, 33, 90),
    rgb(11, 28, 77),
    rgb(12, 33, 90),
    rgb(15, 41, 114)
  );
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  overflow-y: auto;
}
h1 {
  font-size: large;
}

.mainInfo {
  padding: 12px;
  padding-left: 24px;
  padding-right: 24px;
  color: rgb(180, 220, 255);
  max-width: 900px;
  max-height: 100%;
}
.objetivo {
  color: rgb(83, 215, 255);
}
.detInfos,
.pInfos {
  display: flex;
  flex-direction: column;
}
.tRes {
  font-size: 14px;
  color: rgb(210, 234, 255);
  padding-top: 2px;
}
.tittle {
  color: rgb(111, 221, 197);
  padding-bottom: 2px;
  margin-bottom: 0px;
  text-transform: uppercase;
  border-bottom: solid 0.5px rgba(240, 248, 255, 0.37);
}
p {
  margin-top: 2px;
  display: flex;
}
h1 {
  font-size: 16px;
}
.nome {
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  padding-right: 24px;
  margin-top: 16px;
  font-weight: 700;
}
h3 {
  color: rgb(124, 240, 255);
}
ul {
  margin: 2px;
}
.infoExt {
  color: rgb(149, 192, 230);
}

@media (max-width: 900px) {
  .hello {
    flex-direction: column;
  }
  .panLat {
    padding: 12px;
    background: rgb(54, 54, 54);
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    overflow-y: auto;
  }
  .pLatInfos {
    padding: 12px;
    width: calc(100% - 46px);
  }
}
.strong{
  font-weight: 500;
  color: rgb(102, 214, 140);
}
.detItemQ{
  display: flex;
  gap: 4px;
}
.bnone{
  border: none;
}
</style>
